import { createNode } from '@glueapp/graph-types';

export const GetRandomItemFromList = createNode({
    id: 'Get Random Item from List',
    name: 'Get Random Item from List',
    description: 'Gets a random Item from a List',
    aiDescription: 'Picks a random item from a list. Connect a list to "List". Output: "Random Item". Throws if the list is empty.',
    category: 'List',
    color: '#778ed5',
    integration: undefined,
    inPorts: {
        List: {
            kind: 'array',
            subType: {
                kind: 'generic',
                identifier: 'T',
            },
        },
    },
    outPorts: {
        'Random Item': {
            kind: 'generic',
            identifier: 'T',
        },
    },
    execute: function (input) {
        const inputArray = input.inPorts.List;
        if (inputArray.length === 0) {
            throw new Error(`Input List has 0 elements`);
        } else {
            const index = Math.floor(Math.random() * inputArray.length);
            return { output: { 'Random Item': inputArray[index] } };
        }
    },
});
